import { render, staticRenderFns } from "./LabLocationMaintenance.vue?vue&type=template&id=0cc98b4a&scoped=true&"
import script from "./LabLocationMaintenance.vue?vue&type=script&lang=js&"
export * from "./LabLocationMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./LabLocationMaintenance.vue?vue&type=style&index=0&id=0cc98b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc98b4a",
  null
  
)

export default component.exports